import type { ChartData } from '@/types/chart';

const BASE_URL = 'https://handscape.poker';

interface HeadMeta {
  meta: Array<{ title: string } | { name: string; content: string } | { property: string; content: string }>;
}

/**
 * Build route-specific head meta for a chart page.
 * Can accept ChartData directly or simple title/path parameters.
 */
export function buildChartHeadMeta(
  options: { chartData: ChartData; ogImagePath: string } | { title: string; description?: string; ogImagePath: string },
): HeadMeta {
  const title = 'chartData' in options ? `${options.chartData.name} - Handscape` : `${options.title} - Handscape`;

  const description = 'chartData' in options ? options.chartData.description : options.description;

  const ogImageUrl = `${BASE_URL}${options.ogImagePath}`;

  const meta: HeadMeta['meta'] = [
    { title },
    { property: 'og:title', content: title },
    { property: 'og:image', content: ogImageUrl },
    { property: 'twitter:title', content: title },
    { property: 'twitter:image', content: ogImageUrl },
  ];

  // Add description if available
  if (description) {
    meta.push(
      { name: 'description', content: description },
      { property: 'og:description', content: description },
      { property: 'twitter:description', content: description },
    );
  }

  return { meta };
}
